import React from 'react';
import './DiscardAllButton.scss';
var DiscardAllButton = function (_a) {
    var onClick = _a.onClick, text = _a.text;
    return (React.createElement("button", { className: 'BulkDiscardDocument', onClick: onClick }, text));
};
export default DiscardAllButton;
